import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LineChart = function LineChart(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M19.475 36.975L13.762 19H11v-2h4.238l4.3 13.55 8.95-26.45L37.2 28H40v2h-4.2l-7.25-19.875-9.075 26.85z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M41.112 47.313l-1.425-1.425 4.9-4.888-4.9-4.888 1.425-1.425 6.3 6.313-6.3 6.313zM2.1 8.312L.687 6.9 7 .587 13.313 6.9 11.9 8.312 7 3.412l-4.9 4.9z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M46 42H6V2h2v38h38v2z",
      fill: color
    })]
  });
};
export default LineChart;